import { apiJWT } from "api/api-jwt";

interface PUTLicensePayload {
  qtyLicenseMaster: number;
  qtyLicenseVendedorOrOperacional: number;
}

interface PUTLicenseResponse extends GETLicensePayload {}

export interface GETLicensePayload {
  start: string;
  end: string;
  activationDate: string;
  expirationDate: string;
  qtyEnabledMaster: number;
  qtyEnabledVendedorOrOperacional: number;
  qtyLicenseMaster: number;
  qtyLicenseVendedorOrOperacional: number;
  pendingQtyLicenseMaster: number; // Licença Master pendente de ativação
  pendingQtyLicenseVendedorOrOperacional: number; // Licença Vendedor/Operacional pendente de ativação
  configured: boolean;
  userCanRenew: boolean;
  expired: boolean;
}

export class UserLicensesEndpoints {
  static async putLicense(customerId: number, data: PUTLicensePayload) {
    const response = await apiJWT.put<PUTLicenseResponse>(
      `/customers-license-users/${customerId}`,
      data
    );
    return response.data;
  }

  static async getLicense(customerId: number) {
    const response = await apiJWT.get<GETLicensePayload>(
      `/customers-license-users/${customerId}`
    );
    return response.data;
  }
}
